<template>
  <b-row>
    <div
      id="loadingmessage"
      style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
      v-if="loading"
    >
      <p style="position: absolute; color: White; top: 40%; left: 50%;">
        <img src="../../assets/loader.gif" />
      </p>
    </div>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <div slot="header" v-html="caption"></div>
          <div v-if="data.length > 0">
            <b-table
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="data"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              class="table-responsive cnt"
            >
            <template id="pdcy" slot="turtleImage" slot-scope="item" style="text-align:center;">
              <img v-if="item.item.turtleImage!=null" v-bind:src="'http://13.232.14.77/'+item.item.turtleImage" width="50px" height="50px" />
              <p v-else>No Image</p>
            </template>
            </b-table>
            <nav>
           <router-link to="/listturtles"> <button class="btn btn-outline-secondary" style="color:black">View More</button></router-link>
            </nav>
          </div>
          <div v-else>
            <p>No List Found</p>
          </div>
        </b-card>
      </transition>
    </b-col>    
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  name: "Users",
  props: {
    caption: {
      type: String,
      default: "List of Turtles"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      type: localStorage.getItem("type"),
      errors: [],
      data: [],
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt "
        }, 
        {
          key: "type",
          label: "Type",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt"
        },
        {
          key: "iucn",
          label: "IUCN",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt-"
        },
        {
          key: 'turtleImage',
          label: 'Turtle Image',
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt-"
        },
        // {
        //   label: " Action",
        //   key: "_id",
        //   sortable: false,
        //   thClass: "cnt",
        //   tdClass: "cnt"
        // }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      loading: false
    };
  },
  mounted: function() {
    this.getList();
  },
  methods: {
    delturt(val) {
       this.loading = true;
      if (confirm("Are you sure?")) {
        this.loading = true;
        var data1={}
        data1["id"]=val
        data1["x-auth-token"]=localStorage.getItem("token")
        axios({
          method: "POST",
          data: data1,
          url: "/turtle/remove/"
        })
          .then(response => {
             this.loading = false;
            if (response.data.status) { 
              this.getList();
              this.msg = response.data.msg;
            } else {
              this.loading= false;
              this.$router.push({ name: "listturtles" });
            }
          })
          .catch(err => {
             this.loading= false;
            this.errors.push(err);
            this.$router.push({ name: "listturtles" });
          });
      }
    },
    getList() {
      this.loading = true;
      axios({
        method: "GET",
        url: "/turtle/getlist",
        
      })
        .then(response => {
          this.loading = false;

          if (response.data.status === true) {
              for(var i=0;i<5;i++)
              {
                this.data[i] = response.data.data[i];
              }
           
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch(e => {
          this.loading = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },

    getBadge(status) {
      return status === "sucess"
        ? "success"
        : status === "initiate"
        ? "secondary"
        : status === "progress"
        ? "warning"
        : status === "failure"
        ? "danger"
        : "primary";
    },
    getRowCount(data) {
      return data.length;
    },
     // userLink(id) {
    //   return `users/${id.toString()}`;
    // },
    // rowClicked(data) {
    //   const userLink = this.userLink(data._id);
    //   this.$router.push({ path: userLink });
    // }
  }
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.cnt{
  text-align:center!important;
}
</style>
